<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

        <template v-slot:card-header>
          <router-link :to="{ name: `${routePrefix}.dispatcher_performance_report`}" class="btn btn-primary btn-sm"  v-can:report="permissionPrefix">
            <span><i class="fa fa-file-export"></i> {{ $t(`${transPrefix}.dispatcher_performance_report`) }}</span>
          </router-link>
        </template>

        <template v-slot:card-header-search>
          <search v-model="lastPage" :listHandler="getList"/>
        </template>

        <template v-slot:table-rows>
          <tr v-for="item in items" :key="item.id">
            <td> {{ item.userId }} </td>
            <td> {{ item.userName }} </td>
            <td> {{ item.userRole }} </td>
            <td> {{ item.itemType }} </td>
            <td> {{ item.itemId }} </td>
            <td> {{ item.eventType }} </td>
            <td v-b-tooltip.hover="{ animation: false}" :title="JSON.stringify(item.objectChanges)">
              {{ JSON.stringify(item.eventDetails) | shorten(50) }}
            </td>
            <td class="text-direction-ltr"> {{ item.eventAt | moment("Y-MM-DD hh:mm:ss A")  }} </td>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>

        <template v-slot:card-footer>
          <export-action :crudCode="routePrefix" v-can:report="permissionPrefix"></export-action>
        </template>
      </card-container>
    </div>
  </div>
</template>
<script>

  import {  mapGetters } from "vuex";
  import { AUDIT_LOGS_LIST } from "actions/audit_logs";
  import search from "./partials/search";
  const CRUD_CODE="audit_logs";
  const CRUD_PERMISSION_CODE=`${CRUD_CODE}`;
  export default {
    name: "AuditLogsIndex",
    components:{
      search,
    },
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        tableHeaders:[
          {
            'title':`${CRUD_CODE}.fields.user_id`
          },
          {
            'title':`${CRUD_CODE}.fields.user_name`
          },
          {
            'title':`${CRUD_CODE}.fields.user_role`
          },
          {
            'title':`${CRUD_CODE}.fields.item_type`
          },
          {
            'title':`${CRUD_CODE}.fields.item_id`
          },
          {
            'title':`${CRUD_CODE}.fields.event_type`
          },
          {
            'title':`${CRUD_CODE}.fields.event_details`
          },
          {
            'title':`${CRUD_CODE}.fields.event_date`
          }
        ],
        items: [],
        perPage: 20,
        totalElements: 0,
        lastPage: 0,
      }
    },
    mounted() {
      this.getList();
    },
    computed:{
      ...mapGetters([
        "getSearchFilters","getSearchFiltersIfExists","getSearchFiltersSensitized"
      ])
    },
    methods: {
      getList(){
        this.$store.dispatch(AUDIT_LOGS_LIST,{
          pageId: this.getCurrentPage()-1,
          ...this.getSearchFiltersSensitized
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        });
      },
      pagination(page){
        if (page !== this.getCurrentPage()) {
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page,
              ...this.getSearchFiltersIfExists
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage >=1 ? currentPage : 1);
      },
    }
  };
</script>
